export var EAutoFocusDisabledActionTypes = /*#__PURE__*/function (EAutoFocusDisabledActionTypes) {
  EAutoFocusDisabledActionTypes["SetAutoFocusDisabled"] = "autoFocusDisabled/set";
  return EAutoFocusDisabledActionTypes;
}({});